/**
 * Referral Page Constants
 */

import type { DecalSizeConfig, DecalType } from '../types';

// Referral URL base
export const REFERRAL_URL_BASE = 'https://rumio.world/ref';

// Rewards configuration
export const REFERRAL_REWARDS = {
  PRO_DAYS: 3,
  XP: 500,
  MONTHLY_CAP: 3,
  BADGES: {
    ROOKIE: { name: 'Referral Rookie', threshold: 1 },
    CHAMPION: { name: 'Referral Champion', threshold: 10 },
  },
} as const;

// Qualification requirements
export const QUALIFICATION = {
  AS_IS_SCANS_REQUIRED: 3,
  LEVEL_REQUIRED: 2,
  XP_REQUIRED: 1500,
} as const;

// Decal sizes (in inches at 300 DPI for print)
export const DECAL_SIZES: Record<string, DecalSizeConfig> = {
  small: { label: '2"', width: 600, height: 600, inches: 2 },
  medium: { label: '3"', width: 900, height: 900, inches: 3 },
  large: { label: '4"', width: 1200, height: 1200, inches: 4 },
  vector: { label: 'SVG', width: 300, height: 300, inches: 0 }, // Scalable
} as const;

// Decal types with display info
export const DECAL_TYPES: Record<DecalType, { label: string; description: string }> = {
  circular: {
    label: 'Circular Sticker',
    description: 'Classic round sticker design',
  },
  rectangular: {
    label: 'Bumper Sticker',
    description: '3:1 ratio for bumper stickers',
  },
  square: {
    label: 'Square Badge',
    description: 'Versatile square design',
  },
} as const;

// RUMIO brand colors for decals
export const BRAND_COLORS = {
  primary: '#0077B6', // RUMIO blue
  secondary: '#F4A261', // Accent yellow/orange
  white: '#ffffff',
  black: '#333333',
  lightGray: '#f5f5f5',
} as const;

// Social share platforms
export const SHARE_PLATFORMS = [
  { id: 'twitter', label: 'X', bgColor: 'bg-black', hoverColor: 'hover:bg-gray-800' },
  { id: 'facebook', label: 'Facebook', bgColor: 'bg-blue-600', hoverColor: 'hover:bg-blue-700' },
  { id: 'whatsapp', label: 'WhatsApp', bgColor: 'bg-green-500', hoverColor: 'hover:bg-green-600' },
  { id: 'email', label: 'Email', bgColor: 'bg-gray-600', hoverColor: 'hover:bg-gray-700' },
] as const;

// Copy button animation duration (ms)
export const COPY_FEEDBACK_DURATION = 2000;

// QR Code configuration
export const QR_CONFIG = {
  SIZE: 200,
  LEVEL: 'H' as const,
  BG_COLOR: '#ffffff',
  FG_COLOR: '#000000',
  DOWNLOAD_SIZE: 400,
} as const;

// Cache times for React Query
export const CACHE_TIMES = {
  STATS: 1000 * 60 * 5, // 5 minutes
  CODE: 1000 * 60 * 60, // 1 hour
  REQUIREMENTS: 1000 * 60 * 10, // 10 minutes
} as const;
